import React, { useState, useContext, createContext } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
     const navigate = useNavigate()
     const [isLoggedIn, setIsLoggedIn] = useState(() => {
          return localStorage.getItem('token') !== null;
        });

     const login = (token) => {
          localStorage.setItem('token', token);
          setIsLoggedIn(true);
        };
      
        const logout = () => {
          localStorage.removeItem('token');
             setIsLoggedIn(false);
             toast.success("Logout Successfully");
             
        };

     return (
          <AuthContext.Provider value={{ isLoggedIn, login, logout }}>
               {children}
          </AuthContext.Provider>
     );
};
    
export const useAuth = () => useContext(AuthContext);